import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullhorn, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { CRM_NAV } from './nav';

const STATUS_COLORS: Record<string, string> = {
    draft: 'secondary', scheduled: 'info', active: 'primary', completed: 'success', cancelled: 'dark',
};

const Campaigns: React.FC = () => {
    const { api } = useInternalApi();
    const [campaigns, setCampaigns] = useState<any[]>([]);
    const [byStatus, setByStatus] = useState<any[]>([]);
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => { document.title = 'Campaigns & Outreach - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('crm-api/campaigns/').then(r => {
            if (r.data?.status === 'success') {
                setCampaigns(r.data.data.campaigns || []);
                setByStatus(r.data.data.by_status || []);
                setNote(r.data.data.note || '');
            }
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <InternalShell activeDashboard="customer_relations" subNav={CRM_NAV}>
            <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faBullhorn} className="me-2 text-primary" />Campaigns & Outreach</h2>
            <p className="text-muted mb-4">Bulk messaging campaigns and their delivery outcomes</p>

            <div className="alert alert-secondary small"><FontAwesomeIcon icon={faInfoCircle} className="me-2" />{note}</div>

            {loading ? (
                <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
            ) : (
                <>
                    {byStatus.length > 0 && (
                        <div className="d-flex gap-2 mb-3 flex-wrap">
                            {byStatus.map(s => (
                                <span key={s.status} className={`badge bg-${STATUS_COLORS[s.status] || 'secondary'} p-2`}>{s.status}: {s.count}</span>
                            ))}
                        </div>
                    )}

                    <div className="card border-0 shadow-sm">
                        <div className="card-body p-0">
                            {campaigns.length === 0 ? (
                                <div className="text-center py-5 text-muted">No campaigns have been created yet.</div>
                            ) : (
                                <table className="table table-hover align-middle mb-0">
                                    <thead className="table-light"><tr><th>Campaign</th><th>Status</th><th>Recipients</th><th>Sent</th><th>Delivered</th><th>Failed</th><th>Created by</th></tr></thead>
                                    <tbody>
                                        {campaigns.map(c => (
                                            <tr key={c.id}>
                                                <td><strong>{c.name}</strong><div className="small text-muted">{c.message}</div></td>
                                                <td><span className={`badge bg-${STATUS_COLORS[c.status] || 'secondary'}`}>{c.status}</span></td>
                                                <td>{c.recipients}</td>
                                                <td>{c.sent_count}</td>
                                                <td className="text-success">{c.delivered_count}</td>
                                                <td className={c.failed_count > 0 ? 'text-danger' : ''}>{c.failed_count}</td>
                                                <td className="small">{c.created_by || '—'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </>
            )}
        </InternalShell>
    );
};

export default Campaigns;
